import React, { useMemo } from 'react';
import MediaViewerModal from '../../../../Components/MediaViewer/MediaViewerModal';
import {
	DocumentationFile,
	useDocumentationFileQuery,
} from '../../../../graphql/graphql';
import { prepareDocumentationFileForMediaViewer } from '../../Services/eCardFile.service';
import { PreviewFile } from '../../../../Components/MediaViewer/MediaViewer';
import { useAppContext } from '../../../../Services/AppContext';

interface Props {
	fileId: string;
	onClose: () => void;
}

const ECardFileViewer: React.FC<Props> = ({ fileId, onClose }) => {
	const { data } = useDocumentationFileQuery({
		where: {
			id: fileId,
		},
	});

	const { socketUrl } = useAppContext();

	const file: PreviewFile | undefined = useMemo(() => {
		const documentationFile = data?.documentationFile as DocumentationFile;
		if (documentationFile) {
			return prepareDocumentationFileForMediaViewer(
				documentationFile,
				socketUrl,
			);
		}
	}, [data]);

	if (file) {
		return <MediaViewerModal opened onClose={onClose} file={file} />;
	}

	return <></>;
};

export default ECardFileViewer;
